// extracted by mini-css-extract-plugin
module.exports = {"container":"nD6eEfB6JZvY69L3Uono4","visible":"_3WiNdOrUfeNEf8godVZai5","cancelBtn":"_1sjxWo70pwwKo8Tm23l8I2","icon":"f4pf4eF6ISBNSIDfimLNo","saveBtn":"_2FzJCXQGQul1MkQLSiWJkh"};